import React from 'react';


const HeaderTopS2 = () => {
    return (
        <div className="topbar s2">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-12">
                        <div className="contyact-info-wrap">
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-phone-call"></i>
                                </div>
                                <div className="info-text">
                                    <span>Telephone:</span>
                                    <p>+992 92 798 79 99</p>
                                </div>
                            </div>
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-email"></i>
                                </div>
                                <div className="info-text">
                                    <span>E-mail:</span>
                                    <p>tezroh@mail.ru</p>
                                </div>
                            </div>

                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-location-1"></i>
                                </div>
                                <div className="info-text">
                                    <span>Location:</span>
                                    <p>Khistevarz, Dusti Street № 111,
                                        <br /> Sughd, B.Gafurov</p>
                                </div>
                            </div>

                            <div className="contact-info ms-5">
                                <div className="info-text">
                                    <span><a href="https://mml.tj/">RU</a></span>
                                </div>
                                <div className="info-text">
                                    <span><a href="#/">EN</a></span>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default HeaderTopS2;